<div class="hero-bg hero-bg-news">
  <app-navbar/>
  <header class="d-flex flex-column justify-content-center hero-header">
    <div class="app-container hero-text mx-0">
      <div>
        <h1 class="new-line">{{ 'events.description' | translate }}</h1>
      </div>
    </div>
  </header>
</div>
<div class="news-container">
  <div class="app-container pt-5">
    <h3>{{ 'events.item.title' | translate }}</h3>
    @for (item of items; track item.slug) {
      <app-event-item [item]="item"/>
    }
  </div>
</div>

